module.exports = __webpack_public_path__ + "media/images/naatp-162f51aba6a16bbb312736d59025bea2.png";